import React, { useState, useEffect } from 'react';
import { HashRouter } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { Provider } from 'react-redux';
import { store } from './store';
import { App } from './app/App';
import { LagoonContext } from './AppContext/LagoonContext';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { config } from '@uhg-abyss/web/tools/config';
import { lagoon } from '@optum-lagoon/sdk';

const themeOverride = {
  enterpriseFont: true, // only use this flag for UHC theme
};
const theme = createTheme('uhc', themeOverride);

// Adding router context for proper routing support
export const browser = () => {
  const [lagoonLoading, setLagoonLoading] = useState(true);

  useEffect(() => {
    const initializeLagoon = async () => {
      try {
        await lagoon.initialize(
          'link-enhanced-provider-validation',
          config('APP_ENV') === 'local' ? 'dev' : config('APP_ENV'),
          {
            loadTables: true,
            loadForms: false,
          }
        );
        setLagoonLoading(false);
      } catch {
        setLagoonLoading(false);
      }
    };

    initializeLagoon();
  }, []);

  if (lagoonLoading) {
    return (
      <LoadingOverlay
        isLoading={lagoonLoading}
        loadingTitle="Please Wait"
        ariaLoadingLabel="Page Loading"
        css={{
          'abyss-loading-overlay-root': {
            paddingTop: '500px',
          },
        }}
      />
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <HashRouter>
        <LagoonContext.Provider value={lagoon}>
          <Provider store={store}>
            <div id="root">
              <App />
            </div>
          </Provider>
        </LagoonContext.Provider>
      </HashRouter>
    </ThemeProvider>
  );
};
